import React, { useState } from 'react';
import * as Bixby from '$/core';
import './CloAnalyticsDropDown.scss';

interface IAnalyticsDropDownProps {
  gridView: string;
  setGridView: (selectedOption: string) => void;
}

const CloAnalyticsDropDown: React.FC<IAnalyticsDropDownProps> = props => {
  const { gridView, setGridView } = props;
  const [showOptions, setShowOptions] = useState(false);

  const toggleOptions = () => setShowOptions(!showOptions);

  const onClick = (selectedOption: string) => {
    setGridView(selectedOption);
    setShowOptions(false);
  };

  const analyticsActions = [
    Bixby.Constants.ANALYTICS_VIEW_ALL,
    Bixby.Constants.ANALYTICS_PORTFOLIO,
    Bixby.Constants.ANALYTICS_TRANSACTION_COMPS,
  ];

  return (
    <React.Fragment>
      <div onClick={toggleOptions} className="analytics_dropdown">
        {gridView}
      </div>
      {showOptions && (
        <div className="analytics_dropdown_options_menu">
          {analyticsActions.map(action => {
            return (
              <div className="analytics_dropdown_option" key={action} onClick={() => onClick(action)}>
                {action}
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default CloAnalyticsDropDown;
